/* eslint-disable arrow-body-style */
import http from '@/utils/http';

const prefix = '/api/v1/intelligence_pc';
/*
export const getGenreProfileRegionAndCountriesListWhenOther: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/filterRegionCountryList`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const getGenreProfileRegionAndCountriesListWhenTotalAndMobile: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/filterList`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}
*/
export const getGenreProfileGenreList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/filterGenre`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileSearchRecent: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/market_profile/genre/history/search`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfilePageData: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/table`,
    url: `${prefix}/market_profile/genre/newTable`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 添加数据源筛选器后，新接口
export const getGenreProfileMetricList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `api/v1/intelligence_pc/profile/genre/metric_list`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfilePageDataMobile: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/table`,
    url: `${prefix}/profile/genre/metric_list`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取图片地址
export const getGenreProfileImgDataMobile: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/table`,
    url: `${prefix}/entity/detail`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
export const getGenreProfileLineChartData: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/trend`,
    url: `${prefix}/market_profile/genre/newTrend`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getNewGenreProfileLineChartData: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/trend`,
    url: `${prefix}/profile/genre/metric_list`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getNewGenreProfileInsights: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: `${prefix}/market_profile/genre/trend`,
    url: `${prefix}/profile/genre/insights`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileDetailCrTen: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/genre_profile/detail/insights_cr10/trend`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileDetailNewRelease: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/genre_profile/detail/insights_new_release`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileDetailUpcomming: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/genre_profile/detail/insights_upcomming`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileDetailNewBlockbuster: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/genre_profile/detail/insights_new_blockbuster_game`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileDetailBigriser: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/genre_profile/detail/insights_bigriser`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileStatsTableData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/market_profile/genre/detail_stats`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGenreProfileStatsLineData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/market_profile/genre/detail_stats_trend`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
export const getGenreProfileStatsLine: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/profile/genre/metric_list`,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
